import type { BaseFieldObject } from '@noths/polaris-dev-ts-types';

type ReturnedProduct = {
  product: {
    id: string;
  };
};

/**
 * @schema https://github.com/notonthehighstreet/analytics-schema-definitions/blob/main/objects/impression-list-view.json
 */
export type ProductImpressionsTrackingEvent = {
  event: 'product_impressions';
  event_category: 'Product listings' | 'Rich Relevance';
  event_action: 'Product Impressions' | 'Load More Impressions' | 'Load Previous Impressions';
  event_label: string | null;
  attribution_token?: string;
  ecommerce?: {
    impressions: BaseFieldObject[];
  };
  returned_products?: ReturnedProduct[];
};

interface GetProductImpressionsTrackingEventArgs {
  eventCategory: 'Product listings' | 'Rich Relevance';
  eventAction: 'Product Impressions' | 'Load More Impressions' | 'Load Previous Impressions';
  eventLabel: string | null;
  attributionToken?: string;
  crsFilter?: string;
  impressions?: BaseFieldObject[];
  returnedProducts?: ReturnedProduct[];
}

export const getProductImpressionsTrackingEvent = ({
  eventCategory,
  eventAction,
  eventLabel,
  attributionToken,
  crsFilter,
  impressions,
  returnedProducts,
}: GetProductImpressionsTrackingEventArgs): ProductImpressionsTrackingEvent => {
  return {
    event: 'product_impressions',
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel,
    ...(attributionToken && { attribution_token: attributionToken }),
    ...(crsFilter && { crs_filter: crsFilter }),
    ...(impressions && { ecommerce: { impressions } }),
    ...(returnedProducts && { returned_products: returnedProducts }),
  };
};
